import ReactDOM from "react-dom";
import { IoCloseOutline } from "react-icons/io5";
import { LiaShoppingBagSolid } from "react-icons/lia";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import { moveInRight } from "../../animations/MoveInRight";

const Wrapper = styled.div``;

const DimBackground = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
`;

const Container = styled.div`
  position: fixed;
  top: 40px;
  right: 0;
  height: calc(100vh - 40px);
  width: 380px;
  max-width: 100%;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 60px 40px -7px;
  animation: ${moveInRight} 0.35s ease forwards;
  padding: 25px;
  z-index: 2001;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: auto;
`;

const Header = styled.div`
  width: 100%;
  height: 40px;
  border-bottom: 1px solid ${colors.line};
  color: ${colors.primaryGray};
  display: flex;
  align-self: center;
  justify-content: space-between;
`;

const CloseIcon = styled.div`
  font-size: 24px;
  cursor: pointer;
`;

const Title = styled.div`
  padding-bottom: 24px;
  color: ${colors.black};
  text-transform: uppercase;
  font-size: ${fontSize.s};
`;

const CartItems = styled.div`
  display: flex;
  flex-direction: column;
`;

const EmptyCart = styled.div`
  display: flex;
  height: 70vh;
  gap: 16px;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  svg {
    color: ${colors.blackMuted};
    stroke: currentColor;
  }
`;

const Description = styled.p`
  max-width: 300px;
  text-align: center;
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.primaryGray};
  font-size: ${fontSize.xs};
`;

function SidemenuCart({ onClose, onOpenEdit }) {
  return ReactDOM.createPortal(
    <Wrapper>
      <DimBackground onClick={onClose} />
      <Container>
        <Header>
          <Title>Cart</Title>
          <CloseIcon onClick={onClose}>
            <IoCloseOutline />
          </CloseIcon>
        </Header>
        {/* <CartItems>
          <CartItem onEdit={onOpenEdit} />
          <CartItem onEdit={onOpenEdit} />
        </CartItems> */}

        <EmptyCart>
          <LiaShoppingBagSolid size={40} />
          <Description>
            The cart is empty - discover pieces you love and add them as you
            shop.
          </Description>
        </EmptyCart>
        {/* <CartBilling /> */}
      </Container>
    </Wrapper>,
    document.body
  );
}

export default SidemenuCart;
